import script from "./AboutSubscriptionBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutSubscriptionBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AboutSubscriptionBlock.vue?vue&type=style&index=0&id=3c7d5142&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7d5142"]])

export default __exports__